import {
  IAfterGuiAttachedParams,
  ICellRendererParams,
  INoRowsOverlayParams,
} from '@ag-grid-community/core';
import {
  ICellRendererAngularComp,
  INoRowsOverlayAngularComp,
} from '@ag-grid-community/angular';

import { Component } from '@angular/core';

@Component({
  selector: 'app-no-row-overlay-render',
  templateUrl: './no-row-overlay-render.component.html',
})
export class NoRowOverlayRenderComponent implements INoRowsOverlayAngularComp {
  agInit(params: INoRowsOverlayParams): void {}
}
